import { render } from "./Amount.vue?vue&type=template&id=16b4c74a"
import script from "./Amount.vue?vue&type=script&lang=js"
export * from "./Amount.vue?vue&type=script&lang=js"
script.render = render

export default script